import { render, staticRenderFns } from "./Distri.vue?vue&type=template&id=ef3566a0&scoped=true"
import script from "./Distri.vue?vue&type=script&lang=js"
export * from "./Distri.vue?vue&type=script&lang=js"
import style0 from "./Distri.vue?vue&type=style&index=0&id=ef3566a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3566a0",
  null
  
)

export default component.exports